<template>
  <v-container class="terms-container custom-container" :class="{ 'terms-container--dark': $vuetify.theme.dark }">
    <v-row>
      <v-col cols="12">
        <v-card class="terms-panel elevation-0" elevation="0">
          <v-row dense>
            <v-col cols="12" sm="12">
              <v-card class="terms-panel__inner pa-3 elevation-0">
                <v-card-title class="terms-title">
                  <span class="terms-title__icon"><v-icon>mdi-file-document-outline</v-icon></span>
                  Terms And Condition You Agreed
                </v-card-title>
                <v-sheet class="terms-table-wrap transactionTable depositTabTable">
                  <v-data-table class="terms-table" hide-default-footer :headers="headers" :items="notAcceptedAgreements" no-data-text="No terms and conditions available">
                    <template v-slot:item.agreement_file="{ item }">
                      <a class="links text-decoration-none" target="_blank" rel="noopener noreferrer"
                        :href="item.agreement_file">
                        <img class="mt-2" width="30px" alt="pdf" src="@/assets/pdf-sm.png" />
                      </a>
                    </template>
                    <template v-slot:item.DetailsView="{ item }">
                      <a
                        class="links text-decoration-none mx-2"
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="item.agreement_file"
                      >
                        <v-icon small class="terms-view-icon">
                        mdi-eye-outline
                        </v-icon>
                      </a>
                      <!-- <a
                        class="links text-decoration-none mx-2"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="#"
                        @click.prevent="downloadFile(item.agreement_file)"
                      >
                        <v-icon small color="#14D7B2">
                          mdi-download
                        </v-icon>
                        
                      </a> -->
                    </template>
                  </v-data-table>
                </v-sheet>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import { mapState, mapActions } from "vuex";
import { AGREEMENT__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";

export default {
  data() {
    return {
      dialog: {},
      selectedFile: null,
      uploading: false,
      headers: [
        { text: "Agreement For", value: "title", align: "start" },
        { text: "Uploaded Date", value: "created_at" },
        { text: "Broker's File", value: "agreement_file" },
        { text: "Actions", value: "DetailsView" },
      ],
    };
  },
  computed: {
    ...mapState("agreements", ["notAcceptedAgreements"]),
  },
  methods: {
    ...mapActions("agreements", [AGREEMENT__ACTIONS.NOTACCEPTEDAGREEMENTS, AGREEMENT__ACTIONS.UPLOADAGREEMENTFILE]),

    handleClose(item) {
      this.$set(this.dialog, item?.id, false)
    },

    async downloadFile(url) {
      try {
        const response = await fetch(url, { mode: 'cors' });
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', url.split('/').pop());
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        toast.error("Error downloading file:", error);
      }
    },

    handleFileAdded(file) {
      console.log('File added to dropzone:', file);
      this.selectedFile = file;
      
      // Validate file size
      if (file.size > 2 * 1024 * 1024) {
        toast.error("File size should be less than 2MB");
        this.$refs.myVueDropzone.removeFile(file);
        this.selectedFile = null;
      }
    },
    
    async uploadFile(item) {
      if (!this.selectedFile) {
        toast.error("Please select a file to upload!");
        return;
      }
      
      try {
        this.uploading = true;
        const formData = new FormData();
        formData.append("agreement_id", item.id);
        formData.append("agreement_file", this.selectedFile);
        
        const result = await this[AGREEMENT__ACTIONS.UPLOADAGREEMENTFILE](formData);
        
        if (result !== false) {
          this.handleClose(item);
          this.selectedFile = null; // Clear the selected file
          this.$refs.myVueDropzone.removeAllFiles(); // Clear the dropzone
          this.uploading = false;
        }
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    }
  },
  async created() {
    await this[AGREEMENT__ACTIONS.NOTACCEPTEDAGREEMENTS]();
  },
};
</script>
<style scoped>
.terms-container {
  --panel: #fff;
  --panel-soft: #f4f5f7;
  --border: #dfe2e6;
  --text: #171a1f;
  --muted: #626973;
  --primary: #d99a00;
  color: var(--text);
}
.terms-container--dark {
  --panel: #07111b;
  --panel-soft: #0b1621;
  --border: #293026;
  --text: #f4f5f7;
  --muted: #aeb6c0;
  --primary: #ffc400;
}
.terms-panel, .terms-panel__inner, .terms-table-wrap { background: var(--panel) !important; color: var(--text) !important; }
.terms-panel { overflow: hidden; border: 1px solid var(--border); border-radius: 10px !important; }
.terms-panel__inner { border-radius: 10px !important; }
.terms-title { min-height: 66px; gap: 12px; color: var(--text); font-size: 19px; font-weight: 700; }
.terms-title__icon { width: 40px; height: 40px; display: inline-flex; align-items: center; justify-content: center; color: var(--primary); border: 2px solid var(--primary); border-radius: 50%; }
.terms-title__icon .v-icon, .terms-view-icon { color: var(--primary) !important; }
.terms-table-wrap { overflow: hidden; border: 1px solid var(--border); border-radius: 8px; }
.terms-table { background: var(--panel) !important; color: var(--text) !important; }
.terms-table::v-deep .v-data-table__wrapper { overflow-x: auto; }
.terms-table::v-deep table { min-width: 720px; }
.terms-table::v-deep th { height: 48px; color: var(--muted) !important; border-color: var(--border) !important; background: var(--panel-soft); font-size: 11px; }
.terms-table::v-deep td { height: 58px; color: var(--text) !important; border-color: var(--border) !important; background: var(--panel); font-size: 12px; }
.terms-table::v-deep tbody tr:hover td { background: rgba(217, 154, 0, .075) !important; }
.terms-table::v-deep .v-data-table__empty-wrapper td { height: 180px; color: var(--muted) !important; text-align: center; }
.terms-table::v-deep .v-data-table__empty-wrapper td::before { display: block; margin-bottom: 8px; color: var(--primary); font-family: "Material Design Icons"; font-size: 34px; line-height: 1; content: "\F0219"; }
@media (max-width: 600px) {
  .terms-panel__inner { padding: 10px !important; }
  .terms-title { padding: 10px 4px; font-size: 16px; }
  .terms-title__icon { width: 34px; height: 34px; }
}
</style>
